import { render } from "./content1.vue?vue&type=template&id=fa663be4&scoped=true"
import script from "./content1.vue?vue&type=script&lang=js"
export * from "./content1.vue?vue&type=script&lang=js"

import "./content1.vue?vue&type=style&index=0&id=fa663be4&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa663be4"]])

export default __exports__